export default function About() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            关于番茄影视大全
          </h2>
          <p className="text-sm text-foreground-600">您的专属免费追剧平台</p>
        </div>
        <div className="bg-gradient-to-br from-primary-50/60 to-accent-50/50 rounded-2xl p-6 md:p-10 border border-primary-100/40">
          <div className="flex flex-col md:flex-row items-start gap-8">
            <div className="flex-shrink-0">
              <span className="w-16 h-16 flex items-center justify-center bg-primary-500 rounded-2xl">
                <i className="ri-clapperboard-fill text-background-50 text-2xl"></i>
              </span>
            </div>
            <div>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                番茄影视大全诞生于对优质影视内容的执着追求。我们致力于打造一个全面、便捷、免费的电视剧在线观看平台，让每一位追剧爱好者都能在这里找到心仪的剧集。从最新上线的国产热播剧到经典韩剧、高分美剧、治愈日剧、精彩泰剧，番茄影视大全覆盖海量资源，每日同步更新，确保您不错过任何一部好剧。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                我们的核心理念是「追剧不等待」。通过先进的多线路分发技术和智能清晰度适配，无论您身处何地、使用何种设备，都能享受高清不缓冲的流畅体验。无需下载任何软件或插件，打开浏览器即可开始您的追剧之旅。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                番茄影视大全持续优化内容推荐算法，根据您的观看偏好智能推荐相似剧集，帮助您发现更多惊喜好剧。我们相信，好的影视作品值得被更多人看到，而番茄影视大全正是连接好剧与观众的那座桥梁。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}